import { ready } from "@/lib/ready";
import { onceOptions } from "@/lib/onceOptions";
import { lazyLoad } from "@/lib/lazyLoad";
import { checkHover } from "@/lib/checkHover";
import { on } from "@/lib/dom/on";
import { addClass } from "@/lib/dom/addClass";
import { removeClass } from "@/lib/dom/removeClass";
import { aptip } from "@/lib/tooltip";
import { customerLeftMenuClient } from '@anypromo/shared/api/CustomerLeftMenuClient'
import "@/share/loading";
import { setupAutoComplete } from "./search-suggestions";
import Broweser from "@/lib/browser";

let categoryNav: any;
let accountNav: any;
let shippingCart: any;

let logged: any;
let hasGoodsInCart: any;

let isMobileInited = false;
const InitMobileNavs = async () => {
  const { createApp, provide, ref } = await import('vue')
  const { SiteHeaderMenu, AccountNav, ShoppingCart } = await import('@anypromo/components-mobile/site-header')
  const headerClient = (await import('@anypromo/shared/api/HeaderClient')).default;

  if (!isMobileInited) {

    logged = ref(false)
    hasGoodsInCart = ref(false)

    await headerClient.GetRecentOrdersAndCartGoods().then(resp => {
      const goods = resp.Data.goods.map((p: any) => { return { ...p, uuid: Symbol("uuid") }; })
      const subtotal = resp.Data.subtotal

      hasGoodsInCart.value = !!goods?.length
      logged.value = resp.Data.logged

      categoryNav = createApp(SiteHeaderMenu).mount(".mobile-category .nav-holder") as any
      shippingCart = createApp(ShoppingCart, { subtotal: subtotal, items: goods }).mount(".mobile-cart .cart-holder") as any
      accountNav = createApp(AccountNav)
        .provide("logged", logged)
        .provide("countryCode", "CA")
        .provide("showTools", resp.Data.showTools)
        .provide("orders", resp.Data.orders)
        .mount(".mobile-account .acc-holder") as any
    })

    isMobileInited = true
  }
}

const OpenMenu = async () => {
  await InitMobileNavs()
  categoryNav.OpenNav()
}
const OpenAccount = async () => {
  await InitMobileNavs()
  accountNav.OpenNav()
}
const OpenShippingCart = async () => {
  await InitMobileNavs()
  if (logged.value && hasGoodsInCart.value) shippingCart.OpenNav()
  else window.location.href = "/ShoppingCartMobile.aspx"
}
const ajaxLoadAccount = () => {
  let parms = '';
  const hfIndustry = document.getElementById("hfIndustry") as HTMLInputElement;
  if (hfIndustry && hfIndustry.value != '') {
    parms = '?industry=' + hfIndustry.value;
  }

  fetch('/AjaxHomePageHeader.aspx' + parms, {
    method: "POST",
  }).then(r => r.text())
    .then((data: string) => {
      const arrhead = data.split('^_|_^');

      const isLogin = document.getElementById('isLogin') as HTMLInputElement;
      if (isLogin) {
        isLogin.value = arrhead[0];
      }

      if (arrhead[0] == '1') {
        const head_menu = document.querySelector(".head-signin")! as HTMLElement;
        head_menu.setAttribute('href', "/CustomerAccountSettings.aspx");
      }

      const headLogin = document.getElementById('head-loginin');
      if (headLogin) {
        // 直接使用 innerHTML 追加 HTML 片段
        headLogin.innerHTML += arrhead[2]; // arrhead[2] 是 HTML 片段
      }

      // 获取元素并替换其内容和结构
      const headLoginSpan = document.querySelector('#head-loginin span');
      if (headLoginSpan) {
        headLoginSpan.innerHTML = arrhead[1];
      }

      const cartCount = document.querySelector('#header-cart span');
      if (cartCount) {
        cartCount.innerHTML = arrhead[3];
      }

      const headerCart = document.getElementById('header-cart');
      if (headerCart) {
        // 使用 insertAdjacentHTML 来插入 HTML
        headerCart.insertAdjacentHTML('afterend', arrhead[4]); // arrhead[4] 是 HTML 片段
      }

      const headCouponClipped = document.getElementById('head-couponClipped');
      if (headCouponClipped) {
        headCouponClipped.innerHTML = arrhead[5];
        headCouponClipped.insertAdjacentHTML('afterend', arrhead[6]); // arrhead[6] 是 HTML 片段
      }

      const headPlatinum = document.getElementById('head-nav-platinum');
      if (headPlatinum) {
        headPlatinum.insertAdjacentHTML('beforeend', arrhead[7]); // arrhead[7] 是 HTML 片段
      }
      const UnreadNumber = arrhead[8].replace(/<[^>]+>/g, '');

      setUnreadNumber(UnreadNumber);

      aptip(document.querySelectorAll<HTMLElement>('header .a_glossary'));

      showH('head-loginin')
      showH('head-nav-platinum')
      showH('head-mycart')
      showH('header-couponClipboard')

      BindAccount('head-nav-platinum', '.head-platinum');
    })

}


ready(() => {

  const sx = document.querySelectorAll('.a_glossary')! as NodeListOf<HTMLElement>;
  aptip(sx);

  BindShopByMouseEvent('shopbyevent');
  BindShopByMouseEvent('shopbyindustry');
  BindShopByMouseEvent('shopbyguides');

  on(".mobile-category", "click", (evt: Event) => {
    evt.preventDefault()
    OpenMenu()
  })

  on(".mobile-account", "click", (evt: Event) => {
    evt.preventDefault()
    OpenAccount()
  })

  on(".mobile-cart", "click", (evt: Event) => {
    evt.preventDefault()
    OpenShippingCart()
  })

  const headerMain = document.querySelector("#head-main")!;

  /*
  加载头部菜单数据
   */
  on(headerMain, 'mouseover', ajaxLoadAccount, onceOptions)

  on('.head-category__item, #shopbyindustry, #shopbyevent, #shopbyguides', 'mouseover', () => {
    import('./category').then(f => {
      f.init()
    })
  }, onceOptions)
  on('.head-category__item, #shopbyindustry, #shopbyevent, #shopbyguides', 'touchstart', (evt: Event) => {
    import('./category').then(f => {
      f.init()
    })
  }, onceOptions)

})
ready(() => {
  const searchboxEls = document.querySelectorAll<HTMLInputElement>(".head-search__input");
  searchboxEls.forEach(item => {
    on(item, "focus", () => {
      setupAutoComplete()
    }, onceOptions)

    on(item, "blur", () => {
      if (!Broweser.isSmall()) {
        if (item.value == '') {
          item.placeholder = 'Search by Keywords, Brand or Item #';
        }
      }
    })
  });
});


function gettopbarTimeRemaining (endtime: Date) {
  const t = endtime.getTime() - new Date().getTime();
  const seconds = Math.floor(t / 1000 % 60);
  const minutes = Math.floor(t / 1000 / 60 % 60);
  const hours = Math.floor(t / (1000 * 60 * 60));
  return {
    'total': t,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

const runningTopBarCountdown = new WeakMap<HTMLElement, number>()
function InitTopBarCountdown () {
  const nodes = Array.from(document.querySelectorAll<HTMLElement>('.divtopbarflashdeal'))
  nodes.forEach((node) => {
    const tbcountdown_h = node.querySelector<HTMLElement>('.topbarcountdown-hours')
    const tbcountdown_m = node.querySelector<HTMLElement>('.topbarcountdown-minutes')
    const tbcountdown_s = node.querySelector<HTMLElement>('.topbarcountdown-seconds')
    const tbcountdown_ms = node.querySelector<HTMLElement>('.topbarcountdown-Milliseconds')

    if (!tbcountdown_h || !tbcountdown_m || !tbcountdown_s || !tbcountdown_ms) return

    const total = (parseInt(tbcountdown_h.innerHTML || '0') * 60 * 60 +
                   parseInt(tbcountdown_m.innerHTML || '0') * 60 +
                   parseInt(tbcountdown_s.innerHTML || '0')) * 1000 +
                  parseInt(tbcountdown_ms.innerHTML || '0')

    if (total <= 0) return

    // clear any previous interval for this node
    const prev = runningTopBarCountdown.get(node)
    if (prev) clearInterval(prev)

    const topbarendtime = new Date(Date.now() + total)

    const id = window.setInterval(() => {
      const t = gettopbarTimeRemaining(topbarendtime)
      tbcountdown_h.innerHTML = t.hours.toString()
      tbcountdown_m.innerHTML = t.minutes.toString()
      tbcountdown_s.innerHTML = t.seconds.toString()

      if (t.total <= 0) {
        clearInterval(id)
        runningTopBarCountdown.delete(node)
      }
    }, 1000)

    runningTopBarCountdown.set(node, id)
  })
}

(window as any)["InitTopBarCountdown"] = InitTopBarCountdown;

const showH = (elementId: string) => {
  /*
  
    if (elementId == 'header-couponClipboard') {
      //移除
      removeNode('.popper')
    }
     */
  /*事件只执行一次 */
  on(document.getElementById(elementId)!, 'mouseout', (e: MouseEvent) => {
    lazyLoad("[data-original]", (elem: HTMLElement) => {
      const src = elem.getAttribute("data-original");
      if (src && src.length > 0) {
        elem.setAttribute("src", src);
        elem.removeAttribute("data-original");
      }
    });
  }, onceOptions)
}

ready(() => {
  InitTopBarCountdown()

  const lazyLoadImage = () => {
    lazyLoad("[data-original]", (elem: HTMLElement) => {
      const src = elem.getAttribute("data-original");
      if (src && src.length > 0) {
        elem.setAttribute("src", src);
        elem.removeAttribute("data-original");

      }
    });
    lazyLoad("[data-srcset]", (elem: HTMLElement) => {
      const src = elem.getAttribute("data-srcset");
      if (src && src.length > 0) {
        elem.setAttribute("srcset", src);
        elem.removeAttribute("data-srcset");
      }
    });
  }
  lazyLoadImage();

  initHeight();
})


const timehidden = 100;
const timeShow = 100;

function BindAccount (id: string, div: string) {

  let timer: ReturnType<typeof setTimeout> | null = null;

  // 获取 DOM 元素
  const element = document.getElementById(id);
  const divElement = document.querySelector<HTMLElement>(div);

  // 如果任何一个元素不存在，直接返回
  if (!element || !divElement) return;


  lazyLoad("[data-original]", (elem: HTMLElement) => {
    const src = elem.getAttribute("data-original");
    if (src && src.length > 0) {
      elem.setAttribute("src", src);
      elem.removeAttribute("data-original");
    }
  });

  // mouseover 事件处理
  on(element, 'mouseover', (e: MouseEvent) => {
    if (checkHover(e, element)) {
      if (timer !== null) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        // 切换显示/隐藏
        if (divElement.style.display === 'none' || divElement.style.display === '') {
          divElement.style.display = 'block';
        }

        element.setAttribute('aria-expanded', "true");
        addClass(element, "active");
      }, timeShow);
    }
  });

  // mouseout 事件处理
  element.addEventListener('mouseout', (e: MouseEvent) => {
    if (checkHover(e, element)) {
      if (timer !== null) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        divElement.style.display = 'none';
        element.setAttribute('aria-expanded', "false");
        removeClass(element, "active");
      }, timehidden);
    }
  });
}

function BindShopByMouseEvent (id: string) {
  let timer: ReturnType<typeof setTimeout> | null = null;

  const element = document.getElementById(id);
  if (!element) return;

  const menuBox = element.querySelector('.menu-box') as HTMLElement;
  const navItem = element.closest('.head-nav-item') as HTMLElement;
  const shopByTitle = element.querySelector('.head-nav-item__title') as HTMLElement;

  // if (!menuBox || !shopByTitle) return;

  // 鼠标移入事件
  element.addEventListener('mouseover', (e: MouseEvent) => {
    if (checkHover(e, element)) {
      if (timer !== null) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        menuBox.style.display = 'block'; // 替代 jQuery 的 slideDown
        shopByTitle.setAttribute('aria-expanded', 'true');
        addClass(menuBox.closest('.head-nav-item')!, 'active')
      }, timeShow);
    }
  });

  // 鼠标移出事件
  element.addEventListener('mouseout', (e: MouseEvent) => {
    if (checkHover(e, element)) {
      if (timer !== null) {
        clearTimeout(timer);
      }

      timer = setTimeout(() => {
        menuBox.style.display = 'none'; // 替代 jQuery 的 slideUp
        shopByTitle.setAttribute('aria-expanded', 'false');
        removeClass(menuBox.closest('.head-nav-item')!, 'active')
      }, timehidden);
    }
  });
}

const initHeight = () => {
  const mainSpace = document.getElementById('main-space');
  const headMain = document.getElementById('head-main');

  if (mainSpace && headMain) {
    const headMainHeight = headMain.offsetHeight;
    mainSpace.style.height = `${headMainHeight}px`;
  }
}


window.addEventListener('resize', initHeight, {
  passive: true
})

export { }



function setUnreadNumber (UnreadNumber: string) {

  const pc = document.querySelector<HTMLElement>("#head-message")!;
  const mobile = document.querySelector<HTMLElement>("#head-message-mobile")!;
  const mobileMenu = document.querySelector<HTMLElement>(".message-bell-Number");

  const isLogin = document.querySelector<HTMLInputElement>("#isLogin");
  if (isLogin && isLogin.value == "1") {
    pc.classList.remove('hidden');
    mobile.classList.remove('hidden');
    mobile.querySelector<HTMLElement>('.spanCustomerUnreadMsgNumber')!.innerText = UnreadNumber;
    mobile.querySelector<HTMLElement>('.spanCustomerUnreadMsgNumber')!.innerText = UnreadNumber;
    if (mobileMenu) {
      mobileMenu.classList.remove('hidden');
      mobileMenu.querySelector<HTMLElement>('.spanCustomerUnreadMsgNumber')!.innerText = UnreadNumber;
    }
    if (UnreadNumber != "0" && UnreadNumber != "?")
      mobile.querySelector<HTMLElement>('.spanCustomerUnreadMsgNumber')!.style.display = '';
     else
      mobile.querySelector<HTMLElement>('.spanCustomerUnreadMsgNumber')!.style.display = 'none';
  }
  else {
    pc.classList.add('hidden');
    mobile.classList.add('hidden');
    if (mobileMenu != null) {
      mobileMenu.classList.add('hidden');
    }
  }
}

window.addEventListener("pageshow", function (evt) {
  const isLogin = document.querySelector<HTMLInputElement>("#isLogin");
  if (evt.persisted && isLogin?.value == "1") {
    customerLeftMenuClient
      .GetCustomerLeftMenu(false)
      .then((p: any) => {
        if (p.Code == 200) {
          const UnreadMsgNumber = p.Data.MsgNumber
          setUnreadNumber(UnreadMsgNumber)
        }
      })
  }
});



//header edit
function ajaxOrderStatus () {
  const orderIdInput = document.getElementById('head-orderID') as HTMLInputElement | null;
  const zipInput = document.getElementById('head-Zip') as HTMLInputElement | null;
  const orderSearch = document.getElementById('orderSearch');
  const orderResult = document.getElementById('orderResult');
  const orderResultTitle = document.getElementById('orderResultTitle');
  const orderResultContent = document.getElementById('orderResultContent');

  if (orderIdInput && zipInput && orderIdInput.value && zipInput.value) {
    const url = `/AjaxOrderStatus.aspx?orderID=${orderIdInput.value}&Zip=${zipInput.value}`;

    fetch(url)
      .then(response => response.text())
      .then(data => {
        if (orderSearch) orderSearch.style.display = 'none';
        if (orderResult) orderResult.style.display = 'block';

        if (data === "Processing") {
          if (orderResultTitle) orderResultTitle.textContent = "Processing";
          if (orderResultContent) orderResultContent.innerHTML = "Your order is being processed by your customer care rep. We may reach out to you to finalize details, so please, keep an eye on your inbox.";
        }
        else if (data.startsWith("Pending Proof Approval")) {
          const c = data.split('|');
          if (orderResultTitle) orderResultTitle.textContent = "Pending Proof Approval";
          if (orderResultContent) orderResultContent.innerHTML = `Your order will be sent to our production department soon, but first, we need you to approve your virtual proof (image preview) of your artwork on your product.<br><a href='/CustomerLogin.aspx?returnurl=%2fCustomerOrderDetail.aspx%3fsysno%3d${c[1]}'>Click here to review your design.</a>`;
        }
        else if (data === "In Production") {
          if (orderResultTitle) orderResultTitle.textContent = "In Production";
          if (orderResultContent) orderResultContent.innerHTML = "Your product is being customized. This process can last anywhere from a day to two weeks, depending on the customization process and requested production time.";
        }
        else if (data.startsWith("Shipped") || data.startsWith("Closed") || data.startsWith("Shipping Soon")) {
          const a = data.split('|');
          let track = "";
          let carrir = "";
          let isExistDeliveryDate = "";
          let addressCheckStatus = "";

          if (a.length >= 2) {
            carrir = a[1];
            track = a[2];
            isExistDeliveryDate = a[3];
            addressCheckStatus = a[4];
          }
          if (orderResultTitle) orderResultTitle.textContent = a[0];

          if (carrir && track && isExistDeliveryDate && addressCheckStatus) {
            let strMsg1 = "";
            let strMsg2 = "";
            if (isExistDeliveryDate === '1') {
              strMsg1 = "Your order has been delivered.";
              strMsg2 = "check.";
            } else if (isExistDeliveryDate === '0') {
              strMsg1 = "Your order is on its way to you.";
              strMsg2 = "track.";
            }

            if (addressCheckStatus === '1' || addressCheckStatus === '2') {
              if (carrir === '0') {
                if (orderResultContent) orderResultContent.innerHTML = `${strMsg1} Please <a href='https://wwwapps.ups.com/WebTracking/track?track.x=Track&trackNums=${track}' target='_Blank'>click here</a> to ${strMsg2}`;
              } else if (carrir === '1') {
                if (orderResultContent) orderResultContent.innerHTML = `${strMsg1} Please <a href='https://www.fedex.com/apps/fedextrack/index.html?tracknumbers=${track}' target='_Blank'>click here</a> to ${strMsg2}`;
              } else if (carrir === '4') {
                if (orderResultContent) orderResultContent.innerHTML = `${strMsg1} Please <a href='https://tools.usps.com/go/TrackConfirmAction?tLabels=${track}' target='_Blank'>click here</a> to ${strMsg2}`;
              } else {
                if (orderResultContent) orderResultContent.innerHTML = "Your order is on its way to you.";
              }
            } else {
              if (orderResultContent) orderResultContent.innerHTML = "Your order is on its way to you.";
            }
          } else {
            if (orderResultContent) orderResultContent.innerHTML = "Your order is on its way to you.";
          }
        }
        else if (data === "Cancelled") {
          if (orderResultTitle) orderResultTitle.textContent = "Order Cancelled";
          if (orderResultContent) orderResultContent.innerHTML = "This order was cancelled because it was abandoned or voided. For more information, please, contact your Customer Care Rep by phone, email or Live Chat.";
        }
        else if (data === "Waiting Payment") {
          if (orderResultTitle) orderResultTitle.textContent = "Pending Payment";
          if (orderResultContent) orderResultContent.innerHTML = "Your order will progress when payment clears, but until then, we can't move to the next step. For more information, please, contact your Customer Care Rep by phone, email or Live Chat.";
        }
        else if (data === "0") {
          if (orderResultTitle) orderResultTitle.textContent = "No Result";
          if (orderResultContent) orderResultContent.innerHTML = "No orders match your search terms. Review your order order number and billing postcode. Then, try again. If you believe there may be a problem with your order, you may call customer care to resolve any issues.";
        }
        else {
          if (orderResultTitle) orderResultTitle.textContent = data;
        }
      })
      .catch(error => console.error('Error:', error));
  }
}
function showOrderSearch () {
  const orderResult = document.getElementById('orderResult');
  const orderSearch = document.getElementById('orderSearch');
  if (orderResult) orderResult.style.display = 'none';
  if (orderSearch) orderSearch.style.display = 'block';
}

Object.assign(globalThis, {
  AjaxHomePageHeader: ajaxLoadAccount,
  ajaxOrderStatus,
  showOrderSearch
})